<template>
  <div class="page" :style="{ minHeight: pageHeight + 'px' }">
    <div class="info">
      <div class="title">{{name}}</div>
      <div class="tip">
        您所填写的信息仅用于该活动购买保险使用,
        <span style="color: rgba(45, 217, 122, 1)">请放心填写</span>
      </div>
    </div>
    <div class="write">
      <div class="title">请填写您的信息</div>
      <van-cell-group>
        <van-field v-model="form.name" label="姓名" placeholder="请输入姓名" />
        <van-field
          v-model="form.idType"
          label="证件类型"
          placeholder="请输入证件号码"
        >
          <template #input>
            <div class="btns">
              <div
                class="btn"
                @click="form.idType = '身份证'"
                :class="{ active: form.idType == '身份证' }"
                style="margin-left: 0"
              >
                身份证
              </div>
              <div
                class="btn"
                @click="form.idType = '护照'"
                :class="{ active: form.idType == '护照' }"
              >
                护照
              </div>
              <div
                class="btn"
                @click="form.idType = '其他'"
                :class="{ active: form.idType == '其他' }"
              >
                其他
              </div>
            </div>
          </template>
        </van-field>
        <van-field
          v-show="form.idType != '护照'"
          v-model="form.idCode"
          label="证件号码"
          @blur="blurCompulete('idCode')"
          placeholder="请输入证件号码"
        />
        <van-field
          v-show="form.idType == '护照'"
          v-model="form.idCode"
          label="护照号码"
          placeholder="请输入护照号码"
        />
        <!-- <van-field name="radio" label="性别">
          <template #input>
            <van-radio-group v-model="form.sex" direction="horizontal">
              <van-radio name="1">男</van-radio>
              <van-radio name="2">女</van-radio>
            </van-radio-group>
          </template>
        </van-field> -->
        <van-field
          label="性别"
          placeholder="请选择性别"
          readonly
          v-model="form.sex"
          @click="showSexPicker = true"
        >
        </van-field>
        <!-- <van-field v-model="form.birthDay" label="生日" placeholder="请输入证件号码" >
                <template #input>
                    <div class="inputs">
                        <input v-model="year" style="margin-left:0" type="text" placeholder="年"> -
                        <input v-model="month" type="text" placeholder="月"> -
                        <input v-model="day" type="text" placeholder="日" min="0">
                    </div>
                </template>
            </van-field> -->
        <van-field
          label="生日"
          readonly
          clickable
          name="datetimePicker"
          :value="form.birthday"
          placeholder="点击选择时间"
          @click="showPicker = true"
        >
        </van-field>
        <van-field
          v-model="form.mobile"
          label="手机号"
          placeholder="请输入手机号码"
        />
         <van-field
          v-model="form.remarks"
          label="备注"
          placeholder="请输入备注"
        />
      </van-cell-group>
    </div>

    <div class="sub-box">
      <div class="sub" @click="addNameToList()">提交</div>
    </div>

    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        type="date"
        @confirm="onConfirm"
        :min-date="minDate"
        :max-date="maxDate"
        @cancel="showPicker = false"
      />
    </van-popup>
    <van-popup v-model="showSexPicker" round position="bottom" :style="{ height: '30%' }" >
        <van-picker
          title="选择性别"
          show-toolbar
          :columns="['男','女']"
          @confirm="onConfirmSex"
          @cancel="showSexPicker = false"
        />
      </van-popup>
  </div>
</template>

<script>
import storejs from "store";
import util from "@/libs/util.js";
import moment from "moment";
import {
  Dialog,
  Field,
  Checkbox,
  CheckboxGroup,
  Button,
  Picker,
  Toast,
  Cell,
  CellGroup,
  Radio,
  RadioGroup,
  DatetimePicker,
  Popup,
} from "vant";
import wechatService from "@/services/request/wechatService.js";
import $ from "jquery";
var wx = require("weixin-js-sdk");

export default {
  name: "Mine",
  components: {
    Dialog,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [Toast.name]: Toast,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
  },
  data() {
    return {
      moment: moment,
      publicData: storejs.get("publicData") || {},
      pageHeight: window.innerHeight,
      params: {
        queryKey: "",
        pageNumber: 1,
        pageSize: 10,
      },
      name:'',
      form: {
        idType: "身份证",
        birthday: "",
        mobile:"",
        remarks:"",
      },
      year: "",
      momth: "",
      day: "",
      showPicker: false,
      showSexPicker:false,
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      price: "",
      vxChecked: true,
      baseInfo: {},
      unionId: "",
      openId: "",
    };
  },
  watch: {},
  async mounted() {
    if(this.$page.isInWechat){
      wechatService.auth(
        0,
        ({ openid, unionid }) => {
          if (!!openid && !!unionid) {
            console.log("openId", openid);
            this.unionId = unionid;
            this.openId = openid;
          }
        },
        false
      );
    }
    document.title = "名单填写";
    console.log(decodeURIComponent(window.location.href))
    await this.getDetail();
  },
  beforeDestroy: function () {},
  methods: {
    async getDetail(){
      this.params.accountId = this.$route.query.accountId || "";
      this.params.id =  this.$route.query.id;
      let res = await this.$http.post(
        "/api/collectForm/get",
        this.params
      );
      if (!res.code) {
        console.log("res", res);
        this.name = res.t.title
      }
    },
    async getNameList() {
      this.params.accountId = this.$route.query.accountId || "";
      this.params.collectFormId = this.$route.query.id;
      let res = await this.$http.post(
        "/api/collectForm/getNameList",
        this.params
      );
      if (!res.code) {
        console.log("res", res);
        // this.name = res.t.title
      }
    },
    async addNameToList() {
      this.params.collectFormId = this.$route.query.id;
      let form = {
        accountId: this.$route.query.accountId || "",
        formId: this.$route.query.id,
        idCode: this.form.idCode,
        birthday: this.moment(this.form.birthday).valueOf(),
        idType: this.form.idType,
        name: this.form.name,
        mobile: this.form.mobile,
        sex: this.form.sex,
        collectFormId:this.params.collectFormId = this.$route.query.id,
        remarks:this.form.remarks
      };
      if (form.idType == "身份证") {
        let regIdCode = /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/
          if (regIdCode.test(form.idCode)) {
              console.log("consosososo",this.form.idCode)
              this.form.birthday = this.getBirthdayFromIdCard(this.form.idCode);
              this.form.sex=this.getSexFromIdCard(this.form.idCode)
              console.log("form", this.form);
            }else{
              this.$toast.fail("身份证号填写错误，请检查！");
              return false
            }
      }
      // let res = await this.$http.post("/api/collectForm/addName", form);
      let res = await this.$http.post("/api/collectForm/addNameID", form);
      console.log("ressss",res.t)
      if (!res.code) {
        this.$toast("提交成功！");
      } else{
        // this.$toast("信息填写不完整,请检查！");
        this.$toast.fail(res.msg);
        return false
      }
    },
    blurCompulete(type) {
      if (type == "idCode") {
        if (this.form.idCode.length == 18) {
          if (this.form.idType == "身份证") {
            if (util.isCardID(this.form.idCode)) {
              console.log("consosososo",this.form.idCode)
              this.form.birthday = this.getBirthdayFromIdCard(this.form.idCode);
              this.form.sex=this.getSexFromIdCard(this.form.idCode)
              console.log("form", this.form);
            }else{
              this.$toast.fail("身份证号错误，请检查！");
            }
          }
        }
      }
      
    },
    // 获取生日
    getBirthdayFromIdCard(idCard) {
      //根据身份证计算生日格式1997-00-00
      var birthday = "";
      if (idCard != null && idCard != "") {
        if (idCard.length == 15) {
          birthday = "19" + idCard.substr(6, 6);
        } else if (idCard.length == 18) {
          birthday = idCard.substr(6, 8);
        }
        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      }
      return birthday;
    },
    // 获取性别
    getSexFromIdCard(idCard) {
      var sex = "";
      if (idCard != null && idCard != "") {
        if (idCard.length == 18) {
           sex = idCard.substring(16, 17);
        } else if (idCard.length == 15) {
           sex = idCard.substring(13, 14);
        }
        if (sex % 2 === 0)
            sex = "女"; // 性别代码 1代表男，0代表女，暂时不涉及其他类型性别
          else
            sex = "男";
          return sex;
      }
    },
    onConfirm(time) {
      //   this.value = time;
      console.log("time", new Date(time).getTime());
      this.form.birthday = this.moment(new Date(time).getTime()).format(
        "YYYY-MM-DD"
      );
      this.showPicker = false;
    },
    onConfirmSex(value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
      this.form.sex = value;
      this.showSexPicker = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  padding: 0.15rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .info {
    padding: 0.15rem 0.14rem;
    box-sizing: border-box;
    box-shadow: 0px -4px 6px 0px rgba(0, 26, 17, 0.06),
      0px 4px 6px 0px rgba(0, 26, 17, 0.06);
    flex-shrink: 0;
    .title {
      font-size: 0.18rem;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    .tip {
      font-size: 0.12rem;
      font-family: PingFang;
      font-weight: 500;
      color: #666666;
      margin-top: 0.14rem;
    }
  }
  .write {
    margin-top: 0.3rem;
    flex: 1;
    .title {
      font-size: 19px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
      margin-bottom: 0.1rem;
    }
    .btns {
      display: flex;
      .btn {
        font-size: 0.12rem;
        font-family: PingFang SC;
        font-weight: 400;
        color: #2dd97a;
        padding: 0.04rem 0.14rem;
        border: 1px solid #2dd97a;
        // line-height: 1;
        line-height: 0.1rem;
        margin: 0 0.1rem;
        border-radius: 0.2rem;
        &.active {
          background: #2dd97a;
          color: #fff;
        }
      }
    }
    .inputs {
      display: flex;
      input {
        width: 0.5rem;
        height: 0.25rem;
        border: 1px solid #f1f1f1;
        margin: 0 0.1rem;
        border-radius: 0.05rem;
      }
    }
  }
  .sub-box {
    height: 0.68rem;
    background: #ffffff;
    flex-shrink: 0;
    .sub {
      width: 3.45rem;
      height: 0.45rem;
      background: linear-gradient(125deg, #2ada78 0%, #62db9e 100%);
      border-radius: 0.45rem;
      font-size: 0.13rem;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>

<style lang="scss">
.page {
  .write {
    .van-cell {
      padding: 16px 0;
    }
    .van-cell::after {
      left: 0;
    }
  }
}
</style>